<script type="text/javascript">
    const CommTabelHei = document.documentElement.clientHeight-210;
    const CommTabelAllHei = document.documentElement.clientHeight-150;
    const CommType = "";
	const CommUser = "";
	const CommBuMen = "";
    const CommVer = "ver_1.0";
    function isPhone(val) {
        var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
	function _isMobile() {
		 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		 return flag;
	}
    function isVal(data) {
        var Info = {data:"",Blon:false,};
        try {
            data.forEach((item)=> {
                if(item.Only){
                    if (item.val == "") {
                        item.verify = true;
                        item.msg =item.name+"不能为空";
                        Info.Blon = true;
                        throw Error();
                    }else{
                        item.msg ="";
                        item.verify = false;
                    }
                }
                
            })
        } catch (e) {}
        Info.data = data;
        return Info;
    }
    function isChildVal(data) {
        var Info = {data:"",Blon:false,};
        try {
            data.forEach((item)=> {
                item.Child.forEach((items)=>{
                    if(items.Only){
                        if (items.val == "") {
                            items.verify = true;
                            items.msg =items.name+"不能为空";
                            Info.Blon = true;
                            throw Error();
                        }else{
                            items.msg ="";
                            items.verify = false;
                        }
                    }
                })
            })
        } catch (e) {}
        Info.data = data;
        return Info;
    }
    function isMac(){
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if(isMac){
        return true;    
      }else{
        return false;      
      }
    }
    export default{
        CommTabelHei,
        CommTabelAllHei,
        CommType,
		CommUser,
		CommBuMen,
        isPhone,
        isVal,
        isChildVal,
        isMac,
        CommVer,
		_isMobile,
    }
</script>
